import React from 'react';
import ManageAutorizedPersonsForm from './Components/ManageAuthorizedPersonsForm';

const ManageAuthorizedPersonsPage = () => {
  return (
    <div className="w-full h-full">
      <div className="pb-1">
        <ManageAutorizedPersonsForm />
      </div>
    </div>
  );
};

export default ManageAuthorizedPersonsPage;
